import { Injectable } from '@angular/core';
import { IAction } from '../../../shared/interface/iaction'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { IHeader } from '../../../shared/interface/iheader';
import { HttpObject } from '../../../shared/enum/http-object.enum';
import { HttpHeaderKey, CookiesKey } from '../../../shared/enum/http-header-key.enum';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';

@Injectable()
export class MasterOperationService implements IAction {
  httpService : HttpClientService;
  cookies : CookiesService;
  HeaderData : IHeader[]
  constructor(httpClient : HttpClientService, cookService : CookiesService) { 
     this.httpService = httpClient;
     this.cookies = cookService;
    
  }

  private setPathDataAndHeader(data : any,isDataRequire: boolean, path : string){
    this.httpService.setPath(path);
    if(isDataRequire) {
       this.httpService.setData(data);
    }  
    let val = this.cookies.getCookies(CookiesKey.TOKEN.toString());
    if(val != '') {
      this.HeaderData = [];
      this.HeaderData.push({key : HttpHeaderKey.CONTENTTYPE.toString(), value : HttpObject.JSON.toString()});
      this.HeaderData.push({key : HttpHeaderKey.AUTHORIZATION.toString(), value : val});
      this.httpService.setHeader(this.HeaderData);
    }
    
  }
  public setHeader(headerData : Array<any>) : void {
    if(headerData !== undefined && headerData !== null) {
      headerData.forEach(element => {
          this.HeaderData.push({key : element['key'], value : element['value']});
      });
    }
  }
  public saveDataWithFiles(path: string, data: any, files? : any): Observable<any> {
    this.httpService.setPath(path);
    this.httpService.setData(data);
    this.httpService.setFiles(files);
    this.HeaderData = [];
    this.HeaderData.push({key : HttpHeaderKey.AUTHORIZATION.toString(), value : this.cookies.getCookies(CookiesKey.TOKEN.toString())});
    return this.httpService.postDataWithFile(this.HeaderData);
  }
  public save(path : string, data : any) : Observable<any> {
    this.setPathDataAndHeader(data, true, path);
    return this.httpService.postData();
  }
  public get(path : string) : Observable<any> {
    this.setPathDataAndHeader(null, false, path);
    return this.httpService.getData();
  }
  

  public getFile(path : string) : Observable<any> {
    this.setPathDataAndHeader(null, false, path);
    return this.httpService.loadFileFromUrl();
  }
  public update(path : string, data : any) : Observable<any> {
    this.setPathDataAndHeader(data, true, path);
    return this.httpService.putData();
  }
  public delete(path : string) : Observable<any> {
    this.setPathDataAndHeader(null, false, path);
    return  this.httpService.deleteData();
  }

}



// WEBPACK FOOTER //
// ./src/app/section/master/services/master-operation.service.ts